import React from "react";
import Select from "react-select";

import "./BaseSelect.css";

const BaseSelect = (props) => (
  <Select
    styles={{
      control: (provided, { isFocused }) => ({
        ...provided,
        zIndex: 9998,
        borderColor: props.isInvalid
          ? "#dd3a4a"
          : isFocused
          ? "#54BF8D"
          : "#ced4da",
        boxShadow: isFocused
          ? props.isInvalid
            ? "0 0 0 0.15rem rgba(255, 0, 0, 0.25)"
            : "0 0 0 0.15rem rgba(67, 152, 112, 0.25)"
          : "none",
        "&:hover": {
          borderColor:
            isFocused || props.isInvalid
              ? props.isInvalid
                ? "#dd3a4a"
                : "#54BF8D"
              : "#ced4da",
          boxShadow: isFocused
            ? props.isInvalid
              ? "0 0 0 0.15rem rgba(255, 0, 0, 0.25)"
              : "0 0 0 0.15rem rgba(67, 152, 112, 0.25)"
            : "none",
        },
      }),
      option: (provided, { isSelected }) => ({
        ...provided,
        backgroundColor: isSelected ? "#b2c9c4" : "#FFFFFF",
        "&:hover": {
          backgroundColor: "#54BF8D",
          color: "#FFFFFF",
        },
      }),
      menuPortal: (provided) => ({
        ...provided,
        zIndex: 9998,
      }),
    }}
    noOptionsMessage={props.noOptionsMessage}
    menuPortalTarget={document.body}
    options={props.options}
    onChange={props.onChange}
    hideSelectedOptions={true}
    value={props.value}
    defaultValue={props.defaultValue}
    getOptionLabel={props.getOptionLabel}
    getOptionValue={props.getOptionValue}
    placeholder={props.placeholder}
    isSearchable={props.isSearchable}
    backspaceRemovesValue={props.backspaceRemovesValue}
    escapeClearsValue={props.escapeClearsValue}
    isClearable={props.isClearable}
    isMulti={props.isMulti}
    menuPosition={props.menuPosition}
    isDisabled={props.isDisabled}
    id={props.id}
  />
);

export default BaseSelect;
